import React, { useContext, useEffect, useState } from 'react';
import './Home.css'
import { Button } from '@material-ui/core';
import ChooseCard from '../ChooseCard/ChooseCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBus, faBell } from '@fortawesome/free-solid-svg-icons'
import Footer from '../Footer/Footer';
import FoodTab from '../FoodTab/FoodTab';
import { Link } from 'react-router-dom';
import { OrdersContext, UserContext } from '../../App';

const Home = () => {
    const card1 = {
        title: 'Fast Delivary',
        icon: faBus,
        img: 'https://lh3.googleusercontent.com/2VVKM1ecMlzi8vTxUKi-rk8rPQ55NbpNdE-W6mfRrgtjl6V3bgxUDwd5Fsxf3l0mUq_9Q76WFbObsJgJCYuKuCS8qMcZ8vTMBDTJu2sDHtq8nqhdR6oM91lrNnZhfLY33JxQZPWwbw=w2400'
    }
    const card2 = {
        title: 'A Good Auto Responder',
        icon: faBell,
        img: 'https://lh3.googleusercontent.com/Hcpua2m6E5FZqEO2jp8L03GSOmbpIbKP8S1gOqA0kaOvaMaH-K8zhTwv08ApLewUJprqikV2AX1JEzCPvLNZkhYVaIs2qIXuB0pMobREd_cxpBotsWsueYDSN-U4pKgUJqQV5ii5Iw=w2400'
    }
    const card3 = {
        title: 'Home Delivery',
        icon: faBell,
        img: 'https://lh3.googleusercontent.com/sXWauwCUy7g0KBczx2N1UnCIe5E8JHrZvxN2tC_lktNaXqQpWdoiHkioZB9Pyff-aS_TWc1o1ssf6juNAYclnhI-N66Y05_MlEyVfywU_nUm0AiDXX0hfTfxUd8ydrZRZbF5N6NQYA=w2400'
    }
    const [orders, setOrders] = useState([])
    const [loggedInUser, setLoggedInUser] = useContext(UserContext);
    useEffect(() => {
        fetch('https://red-onion-server-01.herokuapp.com/orders?email=' + loggedInUser.email)
        .then(res => res.json())
        .then(data => setOrders(data))
    }, [loggedInUser.email, orders])
    return (
        <div className="home">
            <div className="text-center">
                <h1 style={{paddingTop: '150px'}}>Best food waiting for your belly</h1>
            </div>
            <div className="meal-container">
            <FoodTab/>
            <Link style={{textDecoration: 'none'}} to="/checkout"><Button variant="contained" color="secondary" className="checkout-btn" disabled={(orders.length === 0)}>Checkout Your Food</Button></Link>   
            </div>
            <div className="container">
                <h2 style={{fontWeight: '500'}}>Why you choose us</h2>
                <p style={{width: '50%'}}>When you take the time to choose, oftentimes, you are rewarded with a great gastronomic experience built around the ambience of the restaurant and the attitude of the staff serving you.</p>
                <div className="mt-5 mb-5 choose-container">
                    <ChooseCard card={card1}/>
                    <ChooseCard card={card2} />
                    <ChooseCard card={card3} />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Home;